export const homeMessages = {
  'home.actionCart': 'Add to cart',
  'home.actionFavorite': 'Favorite',
  'home.adv1.desc': 'Verified listings; fake-one-pay-ten policy',
  'home.adv1.title': 'Authentic',
  'home.adv2.desc': '48h in major cities; next-day in some areas',
  'home.adv2.title': 'Fast shipping',
  'home.adv3.desc': '7-day returns; dedicated support',
  'home.adv3.title': 'Easy returns',
  'home.adv4.desc': 'Know where your food comes from',
  'home.adv4.title': 'Traceability',
  'home.btnBrowse': 'Shop now →',
  'home.btnDeals': "Today's deals →",
  'home.catMore': 'See all →',
  'home.catTitle': 'Top categories',
  'home.category1': 'Fresh Fruits',
  'home.category2': 'Dairy & Beverages',
  'home.category3': 'Grains & Oils',
  'home.category4': 'Local Specialties',
  'home.ctaBtn': 'Get started →',
  'home.ctaDesc': 'Discover more — direct from producers',
  'home.ctaTitle': 'Start shopping with confidence',
  'home.emptyProducts': 'No products on sale right now.',
  'home.enterShop': 'Visit shop',
  'home.flashTagDeal': 'Deal',
  'home.flashTagOff': '-{pct}%',
  'home.flashTip': 'Limited-time low prices',
  'home.flashTitle': 'Flash sale',
  'home.heroAsideLabel': 'On-sale products preview',
  'home.heroSub': 'Quality picks nationwide — farm to table, curated for you',
  'home.heroTag': 'Cross-region digital trade',
  'home.heroTitle': 'From source to your door',
  'home.hotMore': 'More picks →',
  'home.hotTitle': 'Trending',
  'home.lead.cat': 'Jump into the catalog by category—what you see is what you get.',
  'home.lead.cta': 'From browse to checkout—simple and transparent.',
  'home.lead.flash': 'Time-boxed subsidies and deals—great for stock-ups and trials.',
  'home.lead.hot': 'Ranked by sales and reputation to cut decision fatigue.',
  'home.lead.shop': 'Verified shops and signals so you can judge trust at a glance.',
  'home.lead.why': 'Rules and fulfillment that make every checkout calmer.',
  'home.loadFail': 'Failed to load products. Please refresh.',
  'home.loadingHint': 'Loading products…',
  'home.shop1Desc': 'Premium fruits from Xinjiang',
  'home.shop1Name': 'Xinjiang Orchard Flagship',
  'home.shop2Desc': 'Original grains from black soil',
  'home.shop2Name': 'Northeast Grain Supply',
  'home.shop3Desc': 'Fine tea direct from origin',
  'home.shop3Name': 'Yunnan Tea Select',
  'home.shopGoodsSuffix': 'items',
  'home.shopHighlight1': '99.2% good reviews (30d) · 5-year tenure',
  'home.shopHighlight2': '88% direct-from-source · strong repeat',
  'home.shopHighlight3': 'Tea category top · SF Express partner',
  'home.shopTitle': 'Featured shops',
  'home.soldPrefix': 'Sold',
  'home.statDelivery': 'Fast delivery',
  'home.statProducts': 'Curated SKUs',
  'home.statProvinces': 'Provinces',
  'home.statUsers': 'Active users',
  'home.statUsersValue': '100K+',
  'home.trust1': 'Curated sellers & spot checks',
  'home.trust2': 'Cold chain + trunk line',
  'home.trust3': '7-day worry-free returns',
  'home.trust4': 'Traceable origin info',
  'home.trustAria': 'Platform service highlights',
  'home.whyTitle': 'Why us',
};
